import { UserProfile } from './types';
import { getItem, setItem } from '../utils/local-storage';

class OktaUserInfo {
  private static readonly OKTA_USER_STORAGE_KEY_NAME = 'okta-user-info';

  public setOktaUserInfo(oktaUserInfo: UserProfile): void {
    if (process.env.NODE_ENV !== 'production') {
      console.log('Setting Okta user info:', oktaUserInfo);
    }
    setItem(
      OktaUserInfo.OKTA_USER_STORAGE_KEY_NAME,
      JSON.stringify(oktaUserInfo),
    );
  }

  public getOktaUserInfo(): UserProfile {
    const storedData = getItem(OktaUserInfo.OKTA_USER_STORAGE_KEY_NAME);
    
    if (!storedData || storedData === 'undefined') {
      return {
        email: '',
        firstName: 'Demo',
        lastName: 'User',
        sub: '',
      };
    }

    try {
      const userInfo = JSON.parse(storedData) || {};
      return userInfo;
    } catch (error) {
      console.error('Error parsing stored user info:', error);
      return {
        email: '',
        firstName: 'Demo',
        lastName: 'User',
        sub: '',
      };
    }
  }

  public getOktaInitials(): string {
    const userInfo = this.getOktaUserInfo();
    const firstInitial = userInfo.firstName ? userInfo.firstName.charAt(0).toUpperCase() : '';
    const lastInitial = userInfo.lastName ? userInfo.lastName.charAt(0).toUpperCase() : '';
    return `${firstInitial}${lastInitial}` || 'DU';
  }

  public clearOktaUserInfo(): void {
    localStorage.removeItem(OktaUserInfo.OKTA_USER_STORAGE_KEY_NAME);
  }
}

export default new OktaUserInfo();